
import { Course } from '../types';

export const challenging_s7: Course = {
  id: "challenging_s7",
  title: "Challenging a Section 7 Report: Fact over Fiction",
  description: "Learn how to professionally challenge a Cafcass report. Master the 'Schedule of Factual Inaccuracies' and the rules of cross-examination.",
  icon: "🚩",
  totalModules: 12,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/challenging_s7/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "According to the guide, what is the fundamental difference between challenges that fail and those that succeed in family court?",
        "o": [
            "Challenges based on emotional disagreement versus those based on a preference for a different outcome.",
            "Challenges based on subjective feelings versus those based on professional opinions.",
            "Challenges based on subjective disagreement and venting versus those based on objective proof and factual evidence.",
            "Challenges based on the officer's personality versus those based on the judge's personal biases."
        ],
        "a": 2
    },
    {
        "q": "Which of the following is NOT identified as one of the four specific objective flaws to target within a Section 7 report?",
        "o": [
            "Factual Inaccuracies",
            "Procedural Failures",
            "Subjective Opinions",
            "Omissions"
        ],
        "a": 2
    },
    {
        "q": "What is the recommended \"structural defense\" and optimal tool for presenting evidence to the judge when responding to a flawed Section 7 report?",
        "o": [
            "A detailed letter of complaint outlining all grievances.",
            "The 'Schedule of Factual Inaccuracies' structured table.",
            "Long paragraphs of argumentative text.",
            "A personal affidavit expressing strong disagreement with the report's conclusions."
        ],
        "a": 1
    },
    {
        "q": "When formally questioning the officer's process, which two paths are suggested to test the evidence?",
        "o": [
            "Sending an informal email to the officer and filing a personal complaint.",
            "Requesting court permission for written questions (Part 25) and formally asking for the officer's attendance for cross-examination.",
            "Directly confronting the officer outside of court and appealing the report's findings.",
            "Hiring a private investigator and submitting a new, independent report."
        ],
        "a": 1
    },
    {
        "q": "According to the \"CRITICAL RULE\" highlighted in the guide, what type of challenges will judges immediately ignore?",
        "o": [
            "Challenges based on objective proof and factual evidence.",
            "Challenges based on procedural failures and omissions.",
            "Challenges based entirely on 'not liking' the report or the officer.",
            "Challenges that use professional precision in language."
        ],
        "a": 2
    }
]
};
